import { Component, OnInit, ViewChild } from '@angular/core';
import { GlobalService } from 'src/app/global.service';
import {MatTableDataSource} from '@angular/material/table';
import {MatPaginator} from '@angular/material/paginator';
import {MatDialog} from '@angular/material/dialog';
import { UsercreationeditComponent } from './../usercreationedit/usercreationedit.component';
import { LoginService } from 'src/app/Common/Services/login.service';
import {MatSort} from '@angular/material/sort';
import { UserCreateListingComponent } from '../user-create-listing/user-create-listing.component';
import { FormGroup, FormBuilder } from '@angular/forms';

export interface PeriodicElement {
  agentname: string;
  agentid: number;
  
}


@Component({
  selector: 'app-usercreation',
  templateUrl: './usercreation.component.html',
  styleUrls: ['./usercreation.component.css']
})
export class UsercreationComponent implements OnInit {

  userform:FormGroup;
  constructor(public global: GlobalService,private _formbuilder: FormBuilder, public dialog: MatDialog, public loginservice:LoginService) {
    this.userform =this._formbuilder.group({
      search:['']
    })
  }

  displayedColumns: string[] = ['agentid', 'agentname','action'];
  dataSource;
  agentList : PeriodicElement[] = [];

  opencreateeditDialog(agentid,agentname): void {
    sessionStorage.setItem('agentId',agentid);
    sessionStorage.setItem('agentname',agentname);
    const dialogRef = this.dialog.open(UsercreationeditComponent, {
      panelClass:'dialogPopclass'
    });
  }

  opencreatelistDialog(agentid): void {
    sessionStorage.setItem('agentId',agentid);
    const dialogRef = this.dialog.open(UserCreateListingComponent, {
      panelClass:'dialogPopclass',
      width:'88%',
    });
  }

  applyFilter(filterValue: string) {
    this.dataSource.filter = filterValue.trim().toLowerCase();
  }

  @ViewChild(MatSort, {static: true}) sort: MatSort;
  @ViewChild(MatPaginator, {static: true}) paginator: MatPaginator;

  ngOnInit() {

  this.getAgentListing();
  }


  getAgentListing(){
    
    this.loginservice.getagentListing().subscribe((res:any) => {
      if(res.responseBody != undefined){
        console.log("Agent Listing :", res.responseBody);
      
        this.agentList = res.responseBody.Lovlist;
        console.log("Listing:", this.agentList)
        this.dataSource = new MatTableDataSource(this.agentList);
        this.dataSource.sort = this.sort;
        this.dataSource.paginator = this.paginator;
      }
      
    })
  }





}


